var render = function render(_c,_vm){return _c('div',{class:_vm.props.headerClass,attrs:{"role":"heading"}},[_c('h2',{staticStyle:{"font-size":"18px"}},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"muted--text",staticStyle:{"font-size":"12px"}},[_vm._t("info")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }